import script from "./MCPConnector.vue?vue&type=script&setup=true&lang=js"
export * from "./MCPConnector.vue?vue&type=script&setup=true&lang=js"

import "./MCPConnector.vue?vue&type=style&index=0&id=14bdbed0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bdbed0"]])

export default __exports__